<template>
  <div
    style="
      background-color: rgb(246, 247, 248);
      min-height: 100vh;
      padding-bottom: 25px;
    "
  >
    <div id="admin-preloader" v-if="loading">
      <div id="admin-loader-text">Updating</div>
      <div id="admin-loader"></div>
    </div>
    <div id="admin-preloader" v-if="loading1">
      <div id="admin-loader-text">Loading</div>
      <div id="admin-loader"></div>
    </div>
    <div id="admin-preloader" v-if="loading2">
      <div id="admin-loader-text">Deleting</div>
      <div id="admin-loader"></div>
    </div>

    <div v-if="changed">
      <b-container class="col-lg-10 pt-5">
        <h3 class="text-info text-center pt-4 my-4">Customers</h3>
        <el-button type="primary" @click="getStat()">Stat</el-button>
        <el-button
          type="primary"
          size="small"
          class="mt-3 d-block mx-auto"
          @click="dialogFormVisible = true"
          >Update Stat</el-button
        >

        <el-dialog
          title="Update"
          :visible.sync="dialogFormVisible"
          :width="width"
        >
          <p>Enter PidNo</p>
          <el-input-number
            placeholder="Enter PidNo"
            v-model="pidNO"
            :max="1000000000"
          ></el-input-number>
          <p>Enter CusNo</p>
          <el-input-number
            placeholder="Enter CusNo"
            v-model="cusNO"
            :max="1000000000"
          ></el-input-number>
          <span slot="footer" class="dialog-footer">
            <el-button @click="dialogFormVisible = false">Cancel</el-button>
            <el-button type="primary" @click="upStat()">Update</el-button>
          </span>
        </el-dialog>
        <!-- User Interface controls -->
        <b-row>
          <b-col sm="4" class="my-1">
            <b-form-group label="" class="mb-0">
              <b-input-group>
                <b-form-input v-model="filter" placeholder="Search" />
                <b-input-group-append>
                  <b-btn :disabled="!filter" @click="filter = ''">Clear</b-btn>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>

          <b-col sm="5" class="my-1">
            <b-form-group label="" class="mb-0">
              <b-input-group>
                <b-form-select v-model="sortBy" :options="sortOptions">
                  <option slot="first" :value="null">Sort By</option>
                </b-form-select>
                <b-form-select
                  :disabled="!sortBy"
                  v-model="sortDesc"
                  slot="append"
                >
                  <option :value="false">Asc</option>
                  <option :value="true">Desc</option>
                </b-form-select>
              </b-input-group>
            </b-form-group>
          </b-col>

          <b-col sm="3" class="my-1">
            <b-form-group horizontal class="mb-0">
              <b-form-select v-model="perPage">
                <option disabled>per page</option>
                <option :value="10">10</option>
                <option :value="25">25</option>
                <option :value="50">50</option>
                <option :value="100">100</option>
                <option :value="300">300</option>
                <option :value="500">500</option>
                <option :value="1000">1000</option>
              </b-form-select>
            </b-form-group>
          </b-col>
        </b-row>

        <!-- Main table element -->
        <b-table
          show-empty
          stacked="sm"
          :items="items"
          :fields="fields"
          :hover="true"
          head-variant="dark"
          :current-page="currentPage"
          :per-page="perPage"
          :filter="filter"
          :empty-text="emptyText"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          @filtered="onFiltered"
          class="mt-4"
        >
          <template slot="index" slot-scope="data">
            {{ data.index + 1 }}
          </template>

          <template slot="id" slot-scope="row">
            <div>{{ row.value }}</div>
          </template>

          <template slot="products" slot-scope="row">
            <div>{{ prdstat[row.item.owner] }}</div>
          </template>

          <template slot="cell(actions)" slot-scope="row">
            <div class="btn-group" role="group" aria-label="Basic example">
              <a
                size="sm"
                @click.stop="row.toggleDetails"
                class="btn btn-sm btn-primary text-white"
              >
                View
              </a>
              <el-button
                type="primary"
                class=""
                @click="getprd(row.item.id, row.item.owner, row.item)"
                >#prd</el-button
              >
              <a
                size="sm"
                class="btn btn-sm btn-primary text-white"
                tabindex="blank"
                ><router-link
                  :to="{
                    name: 'storehome',
                    params: { storename: row.item.owner },
                  }"
                  ><span class="text-white">Shop</span></router-link
                >
              </a>
              <a
                :href="`tel:${row.item.telephone}`"
                size="sm"
                class="btn btn-sm btn-success text-white"
              >
                Call
              </a>
              <a
                :href="`sms:${row.item.telephone}`"
                size="sm"
                class="btn btn-sm btn-info text-white"
              >
                SMS
              </a>
            </div>
          </template>

          <template slot="row-details" slot-scope="row">
            <div class="container">
              <div class="col-sm-12 col-md-6 m-auto">
                <p>Owner {{ row.item.owner }}</p>
                <h4 class="m-auto text-info text-center pt-4 pb-4">
                  Enter Project Id
                </h4>
                <el-input
                  requried
                  placeholder="Project Id"
                  v-model="inputObj"
                ></el-input>
                <el-button
                  type="primary"
                  class="mt-3"
                  @click="upConfig(row.item.id, row.item.owner, row.item)"
                  >Update</el-button
                >
                <p>Rank</p>
                <el-input-number
                  :precision="2"
                  :step="0.1"
                  placeholder="Rank"
                  v-model="row.item.rank"
                  :max="100"
                ></el-input-number>
                <p>Search</p>
                <el-input
                  placeholder="Search"
                  v-model="row.item.search"
                ></el-input>
                <el-button
                  type="warning"
                  class="mt-3"
                  @click="upShop(row.item.id, row.item)"
                  >Update Shop</el-button
                >
              </div>
            </div>
          </template>
        </b-table>
        <b-col md="6" class="my-1">
          <b-pagination
            :total-rows="totalRows"
            :per-page="perPage"
            v-model="currentPage"
            class="my-0"
          />
        </b-col>
      </b-container>
    </div>
  </div>
</template>

<script>
import db from "../config/FirebaseInit";
import firebase from "firebase/app";
const items = [];
export default {
  name: "manage",
  data() {
    return {
      emptyText: "Loading Records...",
      items: [],
      fields: [
        "index",
        { key: "name", label: "Name", sortable: true },
        { key: "regtel", label: "Telephone", sortable: false },
        { key: "config", label: "Config", sortable: true },
        { key: "location", label: "City", sortable: true },
        { key: "cat", label: "Cat", sortable: true },
        { key: "rank", label: "Rank", sortable: true },
        { key: "products", label: "#Prd", sortable: true },
        { key: "district", label: "District", sortable: true },
        { key: "shoptype", label: "Type", sortable: true },
        { key: "regemail", label: "Email", sortable: true },
        { key: "created", label: "Registered", sortable: true },
        // { key: 'owner', label: 'Owner', sortable: true },
        { key: "actions", label: "Actions" },
      ],
      currentPage: 1,
      perPage: 10,
      totalRows: items.length,
      pageOptions: [10, 25, 50, 100, 300, 500, 1000],
      sortBy: null,
      sortDesc: false,
      filter: null,
      loading: false,
      loading1: false,
      loading2: false,
      changed: true,
      inputObj: "",
      config: {},
      pidNO: 0,
      cusNO: 0,
      dialogFormVisible: false,
      width: "50%",
      prdstat: {},
    };
  },

  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => {
          return { text: f.label, value: f.key };
        });
    },
  },
  methods: {
    getStat() {
      db.collection("aaa")
        .doc("pid")
        .get()
        .then((doc) => {
          this.pidNO = doc.data().pidNo;
          this.cusNO = doc.data().cusNo;
          alert("pidno " + doc.data().pidNo + " cusno " + doc.data().cusNo);
        })
        .catch((error) => alert(error));
    },

    upShop(id, item) {
      db.collection("shops")
        .doc(id)
        .update({
          rank: item.rank,
          search: item.search,
        })
        .then((doc) => {
          alert("shop updated");
        })
        .catch((error) => alert(error));
    },
    getprd(id, owner, item) {
      var secondary = firebase.initializeApp(item.fullconfig, id);
      this.$store.state.secondaryDatabase = secondary.firestore();
      // this.$store.state.secondaryApp = this.$route.params.storename
      this.$store.state.secondaryDatabase.settings({
        timestampsInSnapshots: true,
      });
      this.$store.state.secondaryDatabase
        .enablePersistence({ synchronizeTabs: true })
        .then(() => {
          //console.log("Woohoo! Multi-Tab Persistence!");
        });
      this.$store.state.secondaryDatabase
        .collection("shops")
        .doc(owner)
        .get()
        .then((doc) => {
          var catValues = doc.data().catValues;
          var sum = 0;
          for (let key in catValues) {
            sum += catValues[key];
          }
          //data.products = sum
          alert("prd sum is " + sum);
        })
        .catch((error) => console.log(error));
    },
    upStat() {
      db.collection("aaa")
        .doc("pid")
        .update({
          pidNo: this.pidNO,
          cusNo: this.cusNO,
        })
        .then((doc) => {
          alert("pidno & cusno updated");
        })
        .catch((error) => alert(error));
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    upConfig(id, owner, item) {
      this.loading = true;
      this.changed = false;
      this.config.projectId = this.inputObj;
      console.log("this.config", this.config["projectId"]);
      if (this.config.projectId) {
        this.config.authDomain = this.config.projectId + ".firebaseapp.com";
        this.config.databaseURL =
          "https://" + this.config.projectId + ".firebaseio.com";
        this.config.storageBucket = this.config.projectId + ".appspot.com";
        db.collection("shops")
          .doc(id)
          .update({
            config: this.config,
            hasconfig: true,
          })
          .then((doc) => {
            db.collection("shops")
              .doc(id)
              .get()
              .then((doc) => {
                console.log(doc.data());
                var data = doc.data();
                var secondary = firebase.initializeApp(this.config, id);
                this.$store.state.secondaryDatabase = secondary.firestore();
                // this.$store.state.secondaryApp = this.$route.params.storename
                this.$store.state.secondaryDatabase.settings({
                  timestampsInSnapshots: true,
                });
                this.$store.state.secondaryDatabase
                  .enablePersistence({ synchronizeTabs: true })
                  .then(() => {
                    //console.log("Woohoo! Multi-Tab Persistence!");
                  });
                this.$store.state.secondaryDatabase
                  .collection("shops")
                  .doc(owner)
                  .set(data)
                  .then((id) => {
                    console.log("secondaryDB shop id", id);
                  })
                  .catch((error) => alert(error));
                alert("Project Id Updated");
                this.loading = false;
                this.changed = true;
              })
              .catch((error) => alert(error));
          })
          .catch((error) => alert(error));
      } else {
        alert("Please enter valid config object");
        this.loading = false;
        this.changed = true;
      }
    },
  },
  created() {
    this.loading1 = true;
    this.changed = false;
    if (screen.width > 767) {
      this.width = "50%";
    } else {
      this.width = "85%";
    }
    // if(this.$store.state.users.length != 0){
    //     this.items = this.$store.state.users
    //     this.loading1 = false
    //     this.changed = true
    // }else{
    db.collection("shops")
      .get()
      .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          const data = {
            id: doc.id,
            name: doc.data().name,
            regemail: doc.data().regemail,
            created: doc.data().created.toDate().toLocaleString(),
            regtel: doc.data().regtel,
            cus: doc.data().cus,
            config: doc.data().config.projectId,
            fullconfig: doc.data().config,
            hasconfig: doc.data().hasconfig,
            district: doc.data().district,
            location: doc.data().location,
            cat: doc.data().cat,
            shoptype: doc.data().shoptype,
            owner: doc.data().owner,
            rank: doc.data().rank,
            search: doc.data().search,
          };

          this.items.push(data);
          //this.$store.state.users = this.items
        });
        if (this.items.length == 0) {
          this.emptyText = "There are no records to show";
        }
        db.collection("aaa")
          .doc("prdstat")
          .get()
          .then((doc) => {
            this.prdstat = doc.data().prdno;
          });
        this.loading1 = false;
        this.changed = true;
      });
    //}
  },
};
</script>

<style scoped>
@import url("~@/assets/admin/css/admin-loader.css");
</style>


// WEBPACK FOOTER //
// src/components/Manage.vue